import { createContext } from 'react';

import { Subject } from 'rxjs';

import { ModalControllerProps, ModalsContextProps } from './types';

const ModalsContext = createContext<ModalsContextProps>({
  Modals: {},
  modalController: {} as Subject<ModalControllerProps>,
});

const ModalsConsumer = ModalsContext.Consumer;
const ModalsProvider = ModalsContext.Provider;

export { ModalsContext, ModalsProvider, ModalsConsumer };
